import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom';

const PrivateRoute = ({ component: Component, appState, ...rest }) => (
    <Route
        {...rest}
        render={props => {
            console.log('PROPS MATCH ', props.match);
            let returnComponent = <Component {...props} />;
            if (!appState.auth) {
                returnComponent = (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: {
                                from: props.location
                            }
                        }}
                    />
                );
            } else if (
                appState.auth.user.status == 'pending' &&
                !['/email_confirmation', '/email_verification/:token'].includes(
                    props.match.path
                )
            ) {
                returnComponent = (
                    <Redirect
                        to={{
                            pathname: '/email_confirmation',
                            state: {
                                from: props.location
                            }
                        }}
                    />
                );
            } else if (
                appState.auth.user.status != 'pending' &&
                ['/email_confirmation', '/email_verification/:token'].includes(
                    props.match.path
                )
            ) {
                returnComponent = (
                    <Redirect
                        to={{
                            pathname: '/quotes',
                            state: {
                                from: props.location
                            }
                        }}
                    />
                );
            }

            return returnComponent;
        }}
    />
);
export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/modules/router/PrivateRoute.jsx